module.exports = "img/cancel.4b9715b.svg";